/* Sentimental Pet — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sp-reveal:not(.sp-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sp-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sp-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Parallax suave del hero con el ratón ---------- */
  function initHeroParallax(root) {
    (root || document).querySelectorAll('[data-sp-parallax]').forEach(function (scene) {
      if (reduceMotion || scene.dataset.spReady) return;
      scene.dataset.spReady = '1';
      var strength = parseFloat(scene.dataset.spParallax) || 0;
      if (!strength) return;
      var layers = scene.querySelectorAll('.sp-parallax');
      scene.addEventListener('mousemove', function (e) {
        var r = scene.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        layers.forEach(function (layer) {
          var depth = parseFloat(layer.dataset.depth) || 1;
          layer.style.transform = 'translate3d(' + (-x * strength * depth) + 'px,' + (-y * strength * depth) + 'px,0)';
        });
      });
      scene.addEventListener('mouseleave', function () {
        layers.forEach(function (layer) { layer.style.transform = ''; });
      });
    });
  }

  /* ---------- Manifiesto: palabras que se encienden con el scroll ---------- */
  function initManifiesto(root) {
    (root || document).querySelectorAll('[data-sp-manifiesto]').forEach(function (el) {
      if (el.dataset.spReady) return;
      el.dataset.spReady = '1';
      var html = el.innerHTML;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var out = [];
      (function walk(node, wrapEm) {
        node.childNodes.forEach(function (child) {
          if (child.nodeType === 3) {
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { out.push(part); return; }
              var word = part.replace(/&/g, '&amp;').replace(/</g, '&lt;');
              out.push('<span class="sp-manifiesto__word">' + (wrapEm ? '<em class="sp-accent">' + word + '</em>' : word) + '</span>');
            });
          } else if (child.nodeName === 'BR') {
            out.push('<br>');
          } else {
            walk(child, wrapEm || child.nodeName === 'EM' || child.nodeName === 'I');
          }
        });
      })(tmp, false);
      el.innerHTML = out.join('');
      var words = el.querySelectorAll('.sp-manifiesto__word');
      if (reduceMotion) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      var ticking = false;
      function update() {
        ticking = false;
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var progress = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progress = Math.max(0, Math.min(1, progress));
        var n = Math.round(progress * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  /* ---------- Pasos: paso activo + imagen fija que cambia ---------- */
  function initPasos(root) {
    (root || document).querySelectorAll('[data-sp-pasos]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var pasos = wrap.querySelectorAll('.sp-paso');
      var imgs = wrap.querySelectorAll('.sp-pasos__frame img[data-index]');
      if (!pasos.length) return;
      function activate(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('is-active', i === j); });
        if (imgs.length) {
          var target = wrap.querySelector('.sp-pasos__frame img[data-index="' + i + '"]') || imgs[0];
          imgs.forEach(function (img) { img.classList.toggle('is-active', img === target); });
        }
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate(parseInt(entry.target.dataset.index, 10) || 0);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* ---------- Tarjetas que se inclinan al cursor ---------- */
  function initTilt(root) {
    if (reduceMotion || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-sp-tilt]').forEach(function (card) {
      if (card.dataset.spReady) return;
      card.dataset.spReady = '1';
      var max = parseFloat(card.dataset.spTilt) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Página de producto ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDec = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    format = format || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-sp-producto]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var dataEl = wrap.querySelector('[data-sp-product-json]');
      var data = dataEl ? JSON.parse(dataEl.textContent) : null;
      var moneyFormat = wrap.dataset.moneyFormat;
      var idInput = wrap.querySelector('input[name="id"]');
      var qtyInput = wrap.querySelector('input[name="quantity"]');
      var btn = wrap.querySelector('[data-sp-atc]');
      var btnText = btn ? btn.querySelector('span') : null;
      var labelAdd = wrap.dataset.labelAdd;
      var labelSoldout = wrap.dataset.labelSoldout;
      var priceNow = wrap.querySelector('[data-sp-price]');
      var priceOld = wrap.querySelector('[data-sp-compare]');
      var priceBadge = wrap.querySelector('[data-sp-badge]');
      var stickyPrice = document.querySelector('[data-sp-sticky-price]');
      var discounts = { 1: 0, 2: parseFloat(wrap.dataset.disc2) || 0, 3: parseFloat(wrap.dataset.disc3) || 0 };
      var current = null;

      /* Galería */
      var main = wrap.querySelector('[data-sp-main-img]');
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-sp-thumb]'));
      var gIndex = 0;
      function showImage(i) {
        if (!main || !thumbs.length) return;
        gIndex = (i + thumbs.length) % thumbs.length;
        var t = thumbs[gIndex];
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = t.dataset.src;
          main.srcset = t.dataset.srcset || '';
          main.alt = t.dataset.alt || '';
          main.style.opacity = '1';
        }, 160);
        thumbs.forEach(function (th, j) { th.classList.toggle('is-active', j === gIndex); th.setAttribute('aria-current', j === gIndex ? 'true' : 'false'); });
        /* Centrar la miniatura activa en la tira sin mover la página */
        var strip = t.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          var tr = t.getBoundingClientRect(), sr = strip.getBoundingClientRect();
          strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - sr.width / 2 + tr.width / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (th, i) { th.addEventListener('click', function () { showImage(i); }); });
      var prev = wrap.querySelector('[data-sp-prev]');
      var next = wrap.querySelector('[data-sp-next]');
      if (prev) prev.addEventListener('click', function () { showImage(gIndex - 1); });
      if (next) next.addEventListener('click', function () { showImage(gIndex + 1); });

      /* Variantes */
      function selectedOptions() {
        var sel = [];
        wrap.querySelectorAll('[data-sp-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          sel.push(checked ? checked.value : null);
          var out = fs.querySelector('[data-sp-option-value]');
          if (out && checked) out.textContent = checked.value;
        });
        return sel;
      }
      function findVariant() {
        if (!data) return null;
        var sel = selectedOptions();
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return sel[i] === null || o === sel[i]; });
        }) || null;
      }
      function currentQty() {
        var checked = wrap.querySelector('[data-sp-pack] input:checked');
        return checked ? parseInt(checked.value, 10) : (qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1);
      }
      var isInit = true;
      function render() {
        if (!data) return;
        var v = current;
        var qty = currentQty();
        if (qtyInput) qtyInput.value = qty;
        if (!v) {
          if (btn) { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = wrap.dataset.labelUnavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price, moneyFormat);
        if (priceOld) {
          var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
          priceOld.textContent = hasCompare ? formatMoney(v.compare_at_price, moneyFormat) : '';
          priceOld.hidden = !hasCompare;
          if (priceBadge) {
            priceBadge.hidden = !hasCompare;
            if (hasCompare) priceBadge.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        /* Precios de los packs */
        wrap.querySelectorAll('[data-sp-pack] [data-qty]').forEach(function (opt) {
          var q = parseInt(opt.dataset.qty, 10);
          var d = discounts[q] || 0;
          var full = v.price * q;
          /* Shopify redondea el descuento por unidad hacia abajo */
          var total = q * (v.price - Math.floor(v.price * d / 100));
          var t = opt.querySelector('[data-sp-pack-total]');
          var o = opt.querySelector('[data-sp-pack-old]');
          if (t) t.textContent = formatMoney(total, moneyFormat);
          if (o) o.textContent = d ? formatMoney(full, moneyFormat) : '';
        });
        var packTotal = qty * (v.price - Math.floor(v.price * (discounts[qty] || 0) / 100));
        if (stickyPrice) stickyPrice.textContent = formatMoney(packTotal, moneyFormat);
        if (btn) {
          if (v.available) {
            btn.removeAttribute('disabled');
            if (btnText) btnText.textContent = labelAdd + ' · ' + formatMoney(packTotal, moneyFormat);
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (btnText) btnText.textContent = labelSoldout;
          }
        }
        /* Imagen de la variante (al cargar la página se mantiene la foto de ambiente) */
        if (!isInit && v.featured_media_id && thumbs.length) {
          var idx = thumbs.findIndex(function (t) { return t.dataset.mediaId === String(v.featured_media_id); });
          if (idx > -1 && idx !== gIndex) showImage(idx);
        }
        /* URL compartible */
        if (!isInit && window.history && window.history.replaceState && data.variants.length > 1) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      wrap.querySelectorAll('[data-sp-option] input').forEach(function (input) {
        input.addEventListener('change', function () {
          current = findVariant(); render();
          /* Desplegable de modelos: mostrar el elegido y cerrarlo */
          var dd = input.closest('[data-sp-modelsel]');
          if (dd) {
            var img = input.parentNode.querySelector('label img');
            var ddImg = dd.querySelector('[data-sp-modelsel-img]');
            if (img && ddImg) ddImg.src = img.currentSrc || img.src;
            dd.open = false;
            var r = dd.getBoundingClientRect();
            if (r.top < 0) window.scrollBy({ top: r.top - 90, behavior: 'smooth' });
          }
        });
      });
      wrap.querySelectorAll('[data-sp-pack] input').forEach(function (input) {
        input.addEventListener('change', render);
      });

      /* Pack preseleccionado desde la portada (?pack=2) */
      var params = new URLSearchParams(window.location.search);
      var packParam = params.get('pack');
      if (packParam) {
        var packInput = wrap.querySelector('[data-sp-pack] input[value="' + parseInt(packParam, 10) + '"]');
        if (packInput) packInput.checked = true;
      }
      if (data) {
        var initialId = idInput ? parseInt(idInput.value, 10) : null;
        current = data.variants.find(function (v) { return v.id === initialId; }) || findVariant() || data.variants[0];
        selectedOptions();
        render();
        isInit = false;
      }

      /* ---------- Packs con modelos distintos: un desplegable por llavero ---------- */
      var slotsBox = wrap.querySelector('[data-sp-slots]');
      var mainDd = wrap.querySelector('[data-sp-option] [data-sp-modelsel]');
      var slotsHint = wrap.querySelector('[data-sp-slots-hint]');
      var slotLabel = slotsBox ? (slotsBox.dataset.label || 'Llavero') : 'Llavero';
      var mainSmall = mainDd ? mainDd.querySelector('.sp-modelsel__text small') : null;
      var mainSmallText = mainSmall ? mainSmall.textContent : '';

      function mainValue() {
        var c = wrap.querySelector('[data-sp-option] input:checked');
        return c ? c.value : null;
      }
      function makeSlot(n) {
        var dd = mainDd.cloneNode(true);
        dd.removeAttribute('open');
        dd.setAttribute('data-sp-slot', n);
        dd.querySelectorAll('[data-sp-option-value]').forEach(function (e) { e.removeAttribute('data-sp-option-value'); e.setAttribute('data-sp-slot-value', ''); });
        dd.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var oldId = inp.id;
          inp.id = oldId + '-s' + n;
          inp.name = 'sp-slot-' + n;
          var lab = dd.querySelector('label[for="' + oldId + '"]');
          if (lab) lab.setAttribute('for', inp.id);
          inp.checked = inp.value === mainValue();
          inp.addEventListener('change', function () {
            var img = inp.parentNode.querySelector('label img');
            var ddImg = dd.querySelector('[data-sp-modelsel-img]');
            if (img && ddImg) ddImg.src = img.currentSrc || img.src;
            dd.querySelector('[data-sp-slot-value]').textContent = inp.value;
            dd.open = false;
          });
        });
        var small = dd.querySelector('.sp-modelsel__text small');
        if (small) small.textContent = slotLabel + ' ' + n + ' · ' + mainSmallText.replace(/^[^·]*·\s*/, '');
        dd.classList.add('sp-modelsel--slot');
        return dd;
      }
      function syncSlots() {
        if (!slotsBox || !mainDd) return;
        var qty = currentQty();
        var existing = slotsBox.querySelectorAll('[data-sp-slot]');
        for (var i = existing.length; i > qty - 1; i--) existing[i - 1].remove();
        for (var n = existing.length + 2; n <= qty; n++) {
          var s = makeSlot(n);
          slotsBox.appendChild(s);
          s.classList.add('sp-modelsel--new');
          setTimeout(function (el) { el.classList.remove('sp-modelsel--new'); }.bind(null, s), 1200);
        }
        if (mainSmall) mainSmall.textContent = qty > 1 ? slotLabel + ' 1 · ' + mainSmallText.replace(/^[^·]*·\s*/, '') : mainSmallText;
        if (slotsHint) slotsHint.hidden = qty < 2;
      }
      wrap.querySelectorAll('[data-sp-pack] input').forEach(function (input) {
        input.addEventListener('change', syncSlots);
      });
      syncSlots();

      /* Al añadir un pack con varios llaveros: una línea por modelo (el descuento se aplica igual) */
      var pform = wrap.querySelector('product-form');
      if (pform && data) {
        pform.addEventListener('submit', function (e) {
          var qty = currentQty();
          if (qty < 2 || !slotsBox) return; /* 1 llavero: lo gestiona el formulario normal */
          e.preventDefault();
          e.stopPropagation();
          var ids = [current ? current.id : parseInt(idInput.value, 10)];
          slotsBox.querySelectorAll('[data-sp-slot]').forEach(function (dd) {
            var c = dd.querySelector('input:checked');
            var v = c && data.variants.find(function (x) { return x.options[0] === c.value; });
            ids.push(v ? v.id : ids[0]);
          });
          var counts = {};
          ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
          var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
          btn.classList.add('loading');
          btn.setAttribute('aria-disabled', 'true');
          var spinner = pform.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
          var errBox = pform.querySelector('.product-form__error-message-wrapper');
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) throw new Error(res.description || res.message || 'Error');
              var drawer = document.querySelector('cart-drawer');
              if (!drawer) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
              return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  drawer.renderContents({ id: ids[0], sections: sections });
                  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-pack' });
                });
            })
            .catch(function (err) {
              if (errBox) { errBox.hidden = false; var m = errBox.querySelector('.product-form__error-message'); if (m) m.textContent = err.message; }
            })
            .finally(function () {
              btn.classList.remove('loading');
              btn.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
            });
        }, true);
      }

      /* Barra de compra fija en móvil */
      var sticky = document.querySelector('[data-sp-sticky-atc]');
      var form = wrap.querySelector('.sp-compra__form');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(form);
        var stickyBtn = sticky.querySelector('button');
        if (stickyBtn && btn) stickyBtn.addEventListener('click', function () { btn.click(); });
      }
    });
  }

  /* ---------- Cuenta atrás hasta el fin REAL de la oferta ---------- */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-sp-countdown]').forEach(function (el) {
      if (el.dataset.spReady) return;
      el.dataset.spReady = '1';
      var end = Date.parse(el.dataset.end);
      if (isNaN(end)) return;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var set = function (sel, val) { var n = el.querySelector(sel); if (n) n.textContent = val; };
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          /* La oferta ha terminado: ocultamos el contador y todo lo que dependa de ella */
          document.querySelectorAll('[data-hide-on-end]').forEach(function (n) { n.hidden = true; n.style.display = 'none'; });
          return;
        }
        var s = Math.floor(left / 1000);
        set('[data-d]', Math.floor(s / 86400));
        set('[data-h]', pad(Math.floor(s % 86400 / 3600)));
        set('[data-m]', pad(Math.floor(s % 3600 / 60)));
        set('[data-s]', pad(s % 60));
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  function initAll(root) {
    initCountdown(root);
    initReveal(root);
    initHeroParallax(root);
    initManifiesto(root);
    initPasos(root);
    initTilt(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Editor de Shopify: re-inicializar al cambiar ajustes */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
